// 不合理的接口 qs
// 目前获取头部信息是用的待报名列表接口
// 获取换品数据是用的已报名列表接口

import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { Form, Button, Modal, Tag, message, Spin } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import Container from '@/components/container';
import DycItem from './components/dyc-item';
import { getQuery } from '@/common/utils/browser';
import { getCodeToId } from './utils';
import { fetchFormData, ApplyForm, ApplyAgainForm, getOwnerResource, fetchApplyData, queryExtendInfo } from './apis';
import './index.less';

interface Resource {
  accountId: number;
  totalNumber: number;
  usableNumber: number;
}

interface FormData {
  formItemId: string;
  value: string;
}
interface ApplyData {
  checkStatus: number;
  remark: string;
  rejectReason: string;
}

const ResourcePage = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [formItems, setFormItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [applyLoading, setApplyLoading] = useState(false);
  const [header, setHeader] = useState({
    name: '',
    areaId: '',
    applyBeginTimeNew: '',
    applyEndTimeNew: '',
    outActivityId: '',
  });
  const [currentData, setCurrentData] = useState({} as ApplyData);
  const [resource, setResource] = useState({
    areaId: 0,
    batchId: 0,
    accountId: 0,
    totalNumber: 0,
    usableNumber: 0,
  } as Resource);

  const applyId = getQuery('id');
  const id = applyId ? +applyId : '';
  const s = getQuery('batchId');
  const batchId = s ? +s : '';

  const onFinish = (e: any) => {
    const channelId = getCodeToId('channelType', formItems);
    const dptId = getCodeToId('departmentName', formItems);
    e[channelId] = e[channelId][1];
    e[dptId] = e[dptId].indexOf('京东集团') === -1 ? '京东集团-' + e[dptId] : e[dptId];
    apply(e);
  };

  const apply = async (data: any) => {
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: !id ? '确认要申请当前资源申请的信息吗？' : getText(2),
      onOk() {
        const applyItemDTOList: any = [];
        setApplyLoading(true);
        Object.keys(data).forEach((key) => {
          applyItemDTOList.push({
            formItemId: key,
            value: data[key],
          });
        });
        if (!id || currentData.checkStatus !== 2) {
          handlerApply(applyItemDTOList);
        } else {
          handlerApplyAgain(applyItemDTOList);
        }
      },
    });
  };

  // 基础信息
  const fetchData = useCallback(async () => {
    setLoading(true);
    const res = await queryExtendInfo({ resourceId: batchId, resourceType: 3 });
    setLoading(false);
    if (res.ret === '0' && res.data) {
      setHeader(res.data);
      return res.data;
    } else {
      return '';
    }
  }, [batchId]);

  // 报名
  const handlerApply = async (applyItemDTOList: FormData) => {
    const res = await ApplyForm({
      resourceId: batchId,
      accountId: resource.accountId,
      resourceType: 3,
      applyItemDTOList,
    });
    setApplyLoading(false);
    if (res.ret === '0' && res.data && res.data.success) {
      message.success('申请成功');
      fetchOwner();
      setTimeout(() => {
        back();
      }, 1000);
    } else {
      if (res.data && !res.data.success && res.data.message) {
        message.error(res.data.message);
      } else {
        message.error(res.msg);
      }
    }
  };

  // 换品
  const handlerApplyAgain = async (applyItemDTOList: FormData) => {
    const res = await ApplyAgainForm({
      resourceId: batchId,
      accountId: resource.accountId,
      originalApplyId: +id,
      resourceType: 3,
      applyItemDTOList,
    });
    setApplyLoading(false);
    if (res.ret === '0' && res.data && res.data.success) {
      message.success('重新申请成功');
      fetchOwner();
      setTimeout(() => {
        back();
      }, 1000);
    } else {
      if (res.data && !res.data.success && res.data.message) {
        message.error(res.data.message);
      } else {
        message.error(res.msg);
      }
    }
  };

  const onFinishFailed = (e: any) => {
    if (e.errorFields && e.errorFields.length) {
      message.error(e.errorFields[0].errors[0]);
    }
  };

  const fetchForm = useCallback(async (areaId) => {
    setLoading(true);
    const res = await fetchFormData({ areaId });
    setLoading(false);
    if (res.ret === '0' && res.data) {
      setFormItems(res.data.items);
      return res.data.items;
    } else {
      return [];
    }
  }, []);

  const fetchOwner = useCallback(async () => {
    setLoading(true);
    const res = await getOwnerResource({
      resourceId: batchId,
      resourceType: 3,
    });
    setLoading(false);
    if (res.ret === '0' && res.data) {
      setResource(res.data);
    } else {
      return '';
    }
  }, [batchId]);

  const getApplyData = useCallback(async () => {
    const res = await fetchApplyData({ page: 1, pageSize: 10, applyId: id });
    if (res.ret === '0' && res.data) {
      setCurrentData(res.data.items[0]);
      return res.data.items[0].applyItemMicroVOList;
    } else {
      return null;
    }
  }, [id]);

  // 初始化
  useEffect(() => {
    async function init() {
      fetchOwner();
      const data = await fetchData();
      const items = await fetchForm(data.areaId);
      if (items && items.length) {
        const crowdTypeId = getCodeToId('crowdType', items);
        const jumpType = getCodeToId('jumpType', items);
        const formData: any = {};
        formData[crowdTypeId] = '1';
        formData[jumpType] = '0';
        form.setFieldsValue(formData);
      }
    }
    init();
  }, [fetchForm, fetchOwner, form, fetchData]);

  useEffect(() => {
    async function getDetail() {
      if (id && formItems && formItems.length) {
        let data = await getApplyData();
        data = parseFormData(data);
        const fileId = getCodeToId('crowd', formItems);
        const channelId = getCodeToId('channelType', formItems);
        if (+data[channelId] <= 3) {
          data[channelId] = ['01', data[channelId]];
        } else {
          data[channelId] = ['02', data[channelId]];
        }
        form.setFieldsValue(data);
        setTimeout(() => {
          const fileData: any = {};
          fileData[fileId] = data[fileId];
          form.setFieldsValue(fileData);
        }, 300);
      }
    }
    getDetail();
  }, [id, formItems, form, getApplyData]);

  const parseFormData = (data: FormData[]) => {
    const formData: any = {};
    data.forEach((item) => {
      formData[item.formItemId] = item.value;
    });
    return formData;
  };

  const back = () => {
    history.goBack();
  };

  const renderCheck = () => {
    if (currentData.checkStatus === 2 && id) {
      return (
        <Tag
          color="green"
          style={{
            marginLeft: 12,
            borderRadius: 5,
            width: 67,
            textAlign: 'center',
          }}
        >
          已通过
        </Tag>
      );
    } else if (currentData.checkStatus === 3 && id) {
      return (
        <Tag
          color="red"
          style={{
            marginLeft: 12,
            borderRadius: 5,
            width: 67,
            textAlign: 'center',
          }}
        >
          已驳回
        </Tag>
      );
    }
  };

  const getText = (type = 1) => {
    // type 1 是  按钮， 2 是申请modal文案
    if (id) {
      if (currentData.checkStatus === 2) {
        return type === 1 ? '保存设置' : '确认要修改当前资源申请的信息吗？';
      } else if (currentData.checkStatus === 3) {
        return type === 1 ? '重新申请' : '确认要重新申请吗？';
      }
    } else {
      if (resource.usableNumber === 0) {
        return '已申请';
      } else {
        return '确认申请';
      }
    }
  };

  return (
    <Container clearfix padding={{ right: true, left: true }}>
      <div className="apply">
        <div className="title">
          {header.name}-资源位申请
          {renderCheck()}
        </div>
        <div className="sub-title">
          <span>申请资源位：{header.name}</span>
          <span>资源位ID：{header.outActivityId}</span>
          <span>
            报名时间：{header.applyBeginTimeNew} 至 {header.applyEndTimeNew}
          </span>
        </div>
        {id && currentData.checkStatus === 3 && (
          <div className="reject-reason">
            <div className="reject-title">驳回原因</div>
            <div>{currentData.rejectReason || currentData.remark}</div>
          </div>
        )}
        <div className="form-title">基本信息</div>
        <div style={{ width: '100%', textAlign: 'center' }}>{loading && <Spin />}</div>
        <Form
          name="apply"
          form={form}
          className="apply-item"
          scrollToFirstError
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          {formItems.map((item: any) => (
            <DycItem data={item} key={item.code} items={formItems} />
          ))}
          <Form.Item
            className="fixed-btn"
            wrapperCol={{ span: 24 }}
            style={{ height: resource.usableNumber > 0 ? 100 : 81 }}
          >
            <Button style={{ marginRight: 24 }} onClick={() => back()}>
              取消
            </Button>
            <Button type="primary" htmlType="submit" disabled={resource.usableNumber === 0} loading={applyLoading}>
              {getText()}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Container>
  );
};

export default ResourcePage;
